// Idle-time prefetch of the highest-traffic in-app routes. Now that every route is lazy-loaded,
// warming the most likely next destinations while the browser is idle makes navigation feel
// instant without adding anything to the initial load. Each import() primes the same webpack chunk
// that React.lazy resolves, so the chunk is already cached by the time the user clicks.
// requestIdleCallback keeps this strictly off the critical path; failures are ignored silently.
let done = false;

const LIKELY = [
  () => import("../pages/CalendarPage"),
  () => import("../pages/Vault"),
  () => import("../pages/connect/ConnectHub"),
  () => import("../pages/Travel"),
  () => import("../pages/Responsibilities"),
  () => import("../pages/Settings"),
  () => import("../pages/Notifications"),
];

export function prefetchLikelyRoutes() {
  if (done) return;
  done = true;
  const run = () => LIKELY.forEach((load) => { load().catch(() => {}); });
  const ric = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
  ric(run);
}
